export default __webpack_public_path__ + "static/media/disable_next_image.c4eac844.svg";